import React from 'react';
import destinationsData from '../data/destinationsData';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/en';
import { translations as esTranslations } from '../translations/es';
import { VENUE_STYLES } from '../features/weddingBudgetBuilder/data/venueData';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { language } = useLanguage();
  const t = language === 'en' ? translations : esTranslations;

  return (
    <footer className="bg-[#181c24] text-white py-12">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row md:justify-between items-center md:items-start gap-8">
        {/* Brand and Copyright */}
        <div className="text-center md:text-left mb-6 md:mb-0">
          <span className="font-playfair text-2xl font-bold tracking-widest text-[#bfa76a]">Assemblage</span>
          <div className="text-white/60 text-sm mt-2">&copy; {new Date().getFullYear()} Assemblage. {t.footer.allRightsReserved}</div>
        </div>
        {/* Resources Links */}
        <div className="text-center md:text-left">
          <h3 className="text-lg font-semibold mb-4 text-[#bfa76a]">{t.nav.resources || (language === 'en' ? 'Resources' : 'Recursos')}</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/resources/guides/top-venues" className="text-white/80 hover:text-[#bfa76a] transition-colors">
                {t.resources.topVenuesTitle}
              </Link>
            </li>
            <li>
              <Link to="/destinations" className="text-white/80 hover:text-[#bfa76a] transition-colors">
                {t.resources.destinationGuidesTitle}
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-white/80 hover:text-[#bfa76a] transition-colors">
                {t.resources.faqTitle}
              </Link>
            </li>
          </ul>
        </div>
        {/* Contact Link */}
        <div className="text-center md:text-right">
          <Link
            to="/contact"
            className="inline-block bg-[#bfa76a] text-[#181c24] font-semibold py-3 px-8 rounded-full text-lg shadow hover:bg-[#a8905d] transition-all duration-300"
          >
            {t.footer.contact}
          </Link>
        </div>
      </div>
    </footer>
  );
} 